import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable, Input } from "@angular/core";
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from "@angular/router";
import { UserData } from "app/shared/service/UserService";
import { BehaviorSubject, Observable, ReplaySubject, Subject } from "rxjs";
import { filter } from "rxjs/operators";
import { KeycloakService } from "keycloak-angular";
import * as _ from "underscore";
import { PracticeSetAccessDialogComponent } from "app/modules/main/content-management/modules/practice-set-detail/practice-set-access-dialog/practice-set-access-dialog.component";
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { AlertMessage } from "app/shared/utils/alertMessage";
import { DatePicker } from "app/modules/main/date-selector/DatePicker";
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import * as moment from "moment";
import { CryptoService } from "app/shared/utils/crypto.service";
import { HelperService } from "./helper.service";

@Injectable({ providedIn: "root" })
export class ApiService {
  eventSource: EventSource | undefined;
  nav = false;
  @Input() tables: any;
  currentVersionId = "1";
  records: any[]; // Change 'any' to the actual type of the records array
  headerForm: FormGroup;
  loading = false;
  newAppBreadcrumb = true;
  showDateSelector = true;
  showApplibraryList = true;
  isDetailHeaderSaveClicked$ = new BehaviorSubject(false);
  sideNavData: any;
  datePickerData: DatePicker = { type: "Day", from: moment(new Date()).format("YYYY-MM-DD") };
  private apiUrl: string = UserData.backend_url + "/v1";
  private apiV2Url: string = UserData.backend_url + "/v2";
  private wordJumbleSubject = new Subject<any>();

  addSetButtonClicked = new EventEmitter<void>();
  addCategoryButtonClicked = new EventEmitter<void>();
  saveButtonClicked = new EventEmitter<void>();
  cancleButtonClicked = new EventEmitter<void>();
  folderCreated = new Subject<any>();
  newQuestionAdded = new EventEmitter<number>();
  seletedQueston = new EventEmitter<number>();
  previousRoute: any = [];
  breadCrumb: any[] = [];
  isProgrammaticNavigation$ = new BehaviorSubject(false);
  liveSessionUserId$ = new BehaviorSubject("");
  currentSessionId$ = new BehaviorSubject("");
  currentRouteState: any;
  horizontalPosition: MatSnackBarHorizontalPosition = "end";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  public dateRange$ = new BehaviorSubject<any>({ type: "Day" });
  disableDetailHeaderSave$ = new BehaviorSubject(false);
  currentMessage = this.dateRange$.asObservable();
  public dateRangeReset$ = new BehaviorSubject<any>(false);
  dateRangeReset = this.dateRangeReset$.asObservable();
  public completeDateRange$ = new BehaviorSubject<any>(false);
  completedCurrentMessage = this.completeDateRange$.asObservable();
  public pageRoute$ = new BehaviorSubject<any>(false);
  pageRouteOb = this.pageRoute$.asObservable();
  waitingForLiveSessioncontent: boolean = false;
  isfirstView: boolean;
  getorganizationlistData = "";
  VectoringAdvVectoringState: string = "";
  private newQuestionAddedSubject = new BehaviorSubject<number>(0);
  private rowDeletedSubject = new Subject<void>();
  rowDeleted$ = this.rowDeletedSubject.asObservable();
  private rowsLengthPerPracticeSet: { [practiceSetId: string]: number } = {};

  // Expose the newQuestionAdded event as an Observable
  newQuestionAdded$ = this.newQuestionAddedSubject.asObservable();
  private rowsSubject = new BehaviorSubject<number>(0);
  rows$ = this.rowsSubject.asObservable();
  teamAnalytics: any;
  activeApps: any[] = [];
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private keycloakService: KeycloakService,
    private crypto: CryptoService,
    private hs: HelperService
  ) {
    if (localStorage.getItem("breadCrumb")) {
      this.breadCrumb = JSON.parse(localStorage.getItem("breadCrumb"));
    }
    router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      }
      if (event instanceof NavigationEnd) {
        this.loading = false;
        this.createBreadCrumb(event);
      }

      // Set loading state to false in both of the below events to hide the spinner in case a request fails
      if (event instanceof NavigationCancel) {
        this.loading = false;
      }
      if (event instanceof NavigationError) {
        this.loading = false;
      }
    });
  }

  isProgrammaticNavigation() {
    return this.isProgrammaticNavigation$;
  }

  createBreadCrumb(event) {
    this.currentRouteState = this.router.getCurrentNavigation().extras.state;
    if ((this.previousRoute[this.previousRoute.length - 1] && this.previousRoute[this.previousRoute.length - 1].url != event.url) || this.previousRoute.length === 0) {
      //   this.router.getCurrentNavigation().extras.state);
      let rt = [this.route.snapshot];
      while (rt["0"].firstChild) {
        rt["0"] = rt["0"].firstChild;
      }
      event["data"] = { name: rt["0"].data.name };
      event["state"] = this.router.getCurrentNavigation().extras.state;
      // event['icon'] = {icon: rt['0'].data.icon}
      this.previousRoute.push(event);
      localStorage.setItem("previous_route", JSON.stringify(this.previousRoute));
    }
  }
  notify(msg) {
    this._snackBar.open(msg, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 5000,
      panelClass: ["green-snackbar"],
    });
  }
  notifyError(msg) {
    this._snackBar.open(msg, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 5000,
      panelClass: ["red-snackbar"],
    });
  }
  notifyInfo(msg) {
    this._snackBar.open(msg, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 5000,
      panelClass: ["yellow-snackbar"],
    });
  }
  // backRoutes() {
  //   const data = this.previousRoute[this.previousRoute.length - 2]
  //   this.router.navigate([data.url], { state: this.previousRoute[this.previousRoute.length - 1].state }).then(() => {
  //     this.previousRoute.pop();
  //     this.previousRoute.pop();
  //     localStorage.setItem('previous_route', JSON.stringify(this.previousRoute));
  //   });
  // }

  async addRoute(remove?: any, name?: string, config?: any, removeIndex?: number) {
    if (removeIndex) {
      this.breadCrumb.splice(removeIndex, 1);
      localStorage.setItem("breadCrumb", JSON.stringify(this.breadCrumb));
      return;
    }
    if (remove) {
      this.breadCrumb = [];
      localStorage.removeItem("breadCrumb");
    }
    let rt = [this.route.snapshot];
    if (name && name.includes("?")) {
      return;
    }
    while (rt["0"].firstChild) {
      rt["0"] = rt["0"].firstChild;
    }
    const ob = JSON.parse(JSON.stringify(rt["0"].data));
    ob["name"] = name ? name : ob["name"];
    if (ob["name"] && this.crypto.isProbablyEncrypted(ob["name"])) {
      //Start Changes(Ishant)
      // ob['nameDec'] = await this.crypto.decryptData(ob['name']);

      ob["name"] = await this.crypto.decryptData(ob["name"]);
      ob["namDec"] = ob["name"];
      //End of changes(Ishant)
    }
    ob["url"] = this.router.url;
    ob["state"] = this.currentRouteState;
    ob["config"] = config;
    if (!_.isUndefined(config)) ob["icon"] = !_.isUndefined(config.icon) ? config.icon : ob["icon"];
    if (this.breadCrumb.length > 0 && this.breadCrumb[this.breadCrumb.length - 1].name === ob.name && _.isUndefined(ob.config)) {
      return;
    }
    this.breadCrumb.push(ob);
    console.log("Breadcrumb - ", this.breadCrumb);

    localStorage.setItem("breadCrumb", JSON.stringify(this.breadCrumb));
  }
  pageRoute(data, i, view?: any) {
    const stateData = { ...data.state, view: view };
    this.router.navigate([decodeURI(data.url)], { state: stateData }).then(() => {
      this.breadCrumb.splice(i + 1, this.breadCrumb.length - 1);
      let arr = JSON.parse(localStorage.getItem("breadcrumbArray"));
      arr[arr.length] = this.breadCrumb;
      localStorage.setItem("breadcrumbArray", JSON.stringify(arr));
      localStorage.setItem("breadCrumb", JSON.stringify(this.breadCrumb));
      this.routeMessage({ data: data, index: i });
    });
  }
  get(url, params = {}): any {
    // SG-7576
    return this.http.get(this.apiUrl + url, { params: params });
  }
  getResponseTypeText(url): Observable<any> {
    return this.http.get(this.apiUrl + url, { responseType: "text" });
  }
  gettextFile(url): any {
    return this.http.get(this.apiUrl + url);
  }

  getV2(url): any {
    return this.http.get(this.apiV2Url + url);
  }

  deleteFile(url, data): any {
    return this.http.post(this.apiUrl + url, data);
  }

  delete(url, params = {}): any {
    // SG-7576
    return this.http.delete(this.apiUrl + url, { params: params });
  }

  deleteWithBody(url: string, body: any, params = {}): any {
    // SG-7576
    return this.http.delete(this.apiUrl + url, { params: params, body: body });
  }

  post(url, data, params = {}): any {
    return this.http.post(this.apiUrl + url, data, { params: params });
  }

  postUserData(liveSessionId, data) {
    let url = this.apiUrl + `/live-session/${liveSessionId}/userdata`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
      keepalive: true,
    });
  }

  getImportURL(url): string {
    return this.apiUrl + "/downloadImages/" + url;
  }

  put(url, data, params = {}): any {
    // SG-7576
    return this.http.put(this.apiUrl + url, data, { params: params });
  }

  patch(url: string, data: any, params = {}): any {
    return this.http.patch(this.apiUrl + url, data, { params: params });
  }

  //   public downloadFile(data): Observable<Blob> {
  //     const url = this.apiUrl + '/downloadFile/';
  //     return this.http.post(url, data, {
  //         responseType: "blob"
  //     });
  // }
  async logmeout() {
    // localStorage.setItem('logout-event', Date.now().toString()); //SG-6756
    const currentURL = window.location.href;
    let baseURL;
    if (currentURL.includes("#")) {
      baseURL = currentURL.substring(0, currentURL.indexOf("#"));
    } else {
      baseURL = currentURL;
    }
    let redirectPath = "#/main/content-management/dashboard";
    const redirectURI = baseURL;
    localStorage.clear();
    await this.keycloakService.logout(redirectURI);
    // .then(() => {
    //   this.keycloakService.clearToken(); // the problem is with this line!!
    // }); //SG-6764
    // this.router.navigate(['/main/content-management/dashboard']);
    // setTimeout(()=>{
    //   localStorage.clear();
    //    this.keycloakService.logout();
    // },100)
  }

  downloadPost(url, data): Observable<Blob> {
    return this.http.post(this.apiUrl + url, data, { responseType: "blob" });
  }
  downloadPostArray(url, data): Observable<ArrayBuffer> {
    return this.http.post(this.apiUrl + url, data, { responseType: "arraybuffer" });
  }

  downloadGet(url): Observable<Blob> {
    return this.http.get(this.apiUrl + url, { responseType: "blob" });
  }
  changeMessage(message: any) {
    this.dateRange$.next(message);
  }
  routeMessage(message: any) {
    this.pageRoute$.next(message);
  }

  changeCompletedMessage(message: any) {
    this.completeDateRange$.next(message);
  }

  public getPsetsCsvData(analyticType: any, selectedDateType: any, pSetId: any, dateRange: any, username: any, gameId?: any): Observable<Blob> {
    let url: any = "";
    if (analyticType) {
      if (selectedDateType == "day" || selectedDateType == "month" || selectedDateType == "year") {
        url =
          this.apiUrl +
          "/practiceSetAnalytics/" +
          pSetId +
          "/recordUsage?selectedUserName=" +
          username +
          "&analyticsType=" +
          analyticType +
          "&usageType=" +
          selectedDateType +
          (gameId ? "&gameId=" + gameId : "");
      } else {
        url = this.apiUrl + "/practiceSetAnalytics/" + pSetId + "/recordUsage?selectedUserName=" + username + "&analyticsType=" + analyticType + "&" + dateRange + (gameId ? "&gameId=" + gameId : "");
      }
    }
    return this.http.get(url, { responseType: "blob" });
  }

  public getPsetsLiveSessionCsvData(analyticType: any, selectedDateType: any, pSetId: any, dateRange: any, username: any, gameId?: any, status?: any): Observable<Blob> {
    let url: any = "";
    if (analyticType) {
      if (selectedDateType == "day" || selectedDateType == "month" || selectedDateType == "year") {
        url =
          this.apiUrl +
          "/practiceSetAnalytics/" +
          pSetId +
          "/recordUsage?selectedUserName=" +
          username +
          "&analyticsType=" +
          analyticType +
          "&usageType=" +
          selectedDateType +
          (gameId ? "&gameId=" + gameId : "") +
          ("&status=" + status);
      } else {
        url =
          this.apiUrl +
          "/practiceSetAnalytics/" +
          pSetId +
          "/recordUsage?selectedUserName=" +
          username +
          "&analyticsType=" +
          analyticType +
          "&" +
          dateRange +
          (gameId ? "&gameId=" + gameId : "") +
          ("&status=" + status);
      }
    }
    return this.http.get(url, { responseType: "blob" });
  }

  public getAtcPsetsLiveSessionCsvData(analyticType: any, selectedDateType: any, pSetId: any, dateRange: any, username: any, gameId?: any, status?: any): Observable<Blob> {
    let url: any = "";
    if (analyticType) {
      if (selectedDateType == "day" || selectedDateType == "month" || selectedDateType == "year") {
        url =
          this.apiUrl +
          "/atc/analytics/practiceSetAnalytics/" +
          pSetId +
          "/recordUsage?selectedUserName=" +
          username +
          "&analyticsType=" +
          analyticType +
          "&usageType=" +
          selectedDateType +
          (gameId ? "&gameId=" + gameId : "") +
          ("&status=" + status);
      } else {
        url =
          this.apiUrl +
          "/atc/analytics/practiceSetAnalytics/" +
          pSetId +
          "/recordUsage?selectedUserName=" +
          username +
          "&analyticsType=" +
          analyticType +
          "&" +
          dateRange +
          (gameId ? "&gameId=" + gameId : "") +
          ("&status=" + status);
      }
    }
    return this.http.get(url, { responseType: "blob" });
  }

  public getFolderCsvData(analyticType: any, selectedDateType: any, folderId: any, dateRange: any): Observable<Blob> {
    let url: any = "";
    if (analyticType) {
      if (selectedDateType == "day" || selectedDateType == "month" || selectedDateType == "year") {
        url = this.apiUrl + "/folderAnalytics/" + folderId + "/recordUsage?analyticsType=" + analyticType + "&usageType=" + selectedDateType;
      } else {
        url = this.apiUrl + "/folderAnalytics/" + folderId + "/recordUsage?analyticsType=" + analyticType + "&" + dateRange;
      }
    }
    return this.http.get(url, { responseType: "blob" });
  }

  public getAtcFolderCsvData(analyticType: any, selectedDateType: any, folderId: any, dateRange: any): Observable<Blob> {
    let url: any = "";
    if (analyticType) {
      if (selectedDateType == "day" || selectedDateType == "month" || selectedDateType == "year") {
        url = this.apiUrl + "/atc/analytics/folderAnalytics/" + folderId + "/recordUsage?analyticsType=" + analyticType + "&usageType=" + selectedDateType;
      } else {
        url = this.apiUrl + "/atc/analytics/folderAnalytics/" + folderId + "/recordUsage?analyticsType=" + analyticType + "&" + dateRange;
      }
    }
    return this.http.get(url, { responseType: "blob" });
  }

  public getUserDetailsCsvData(analyticType: any, selectedDateType: any, username: any, dateRange: any, gameId: any): Observable<Blob> {
    let url: any = "";
    if (analyticType) {
      if (selectedDateType == "day" || selectedDateType == "month" || selectedDateType == "year") {
        url = this.apiUrl + "/userAnalytics/recordUsage/" + username + "?analyticsType=" + analyticType + "&usageType=" + selectedDateType + "&gameId=" + gameId;
      } else {
        url = this.apiUrl + "/userAnalytics/recordUsage/" + username + "?analyticsType=" + analyticType + "&" + dateRange;
      }
    }
    return this.http.get(url, { responseType: "blob" });
  }
  public getContinuePractSet(gameId, practicesetId, lastCreated, gameSubType) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null || organizationId == "" ? "noOrg" : organizationId;
    const url = this.apiUrl + "/organizations/" + organizationId + "/games/" + gameId + "/practicesets/" + practicesetId + "/sessions/" + "?lastCreated=" + lastCreated + "&gameSubType=" + gameSubType;
    return this.http.get(url);
  }
  public getPracticeSetAccess(data) {
    const url = this.apiUrl + `/practiceSetTablesDetailedView/null/${data}?appName=Multigame`;
    return this.http.get(url);
  }
  openModal(): void {
    const dialogRef = this.dialog.open(PracticeSetAccessDialogComponent, {
      width: "490px",
      height: "263px",
      data: { message: "Oops! Your access has been revoked." },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.router.navigate([""]);
      location.reload();
    });
  }
  public getPracticeSetRoles(practiceSetId) {
    const url = this.apiUrl + `/getPracticeSetRoles/${practiceSetId}?appName=Multigame`;
    return this.http.get(url);
  }

  public getFolderRoles(folderId) {
    const url = this.apiUrl + `/getFolderRoles/${folderId}? appName= Multigame`;
    return this.http.get(url);
  }

  public saveWordJumbleData(tableId) {
    const url = this.apiUrl + `/saveFlexTableDataUIVersion/${tableId}? appName= Multigame`;
    return this.http.get(url);
  }

  public sessionCreate(data, gameId, practicesetId) {
    let organizationId: any = "noOrg";
    let sessionsId = localStorage.getItem("sessionsId");
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/organizations/" + organizationId + "/games/" + gameId + "/practicesets/" + practicesetId + "/sessionsUI" + (sessionsId !== null ? "?sessionsId=" + sessionsId : "");
    return this.http.post(url, data);
  }

  public sessionCreateForATCPhraseology(data) {
    const url = this.apiUrl + "/atc-session";
    return this.http.post(url, data);
  }

  public getGameData(PracticeGroupId, practiceSetId) {
    const url = this.apiUrl + "/practiceSetTablesDetailedViewForURL/" + PracticeGroupId + "/" + practiceSetId;
    return this.http.get(url);
  }
  triggerAddSetButtonClicked() {
    this.addSetButtonClicked.emit();
  }

  triggerAddCategoryButtonClicked() {
    this.addCategoryButtonClicked.emit();
  }
  triggerSaveButtonClicked() {
    this.saveButtonClicked.emit();
  }

  triggerCancleButtonClicked() {
    this.cancleButtonClicked.emit();
  }
  setNewQuestionAdded(value: number) {
    this.newQuestionAddedSubject.next(value);
  }
  getNewQuestionAdded() {
    return this.newQuestionAdded.asObservable();
  }
  getSeletedQuestion() {
    return this.seletedQueston.asObservable();
  }
  setSelectedQuestion(value: number) {
    this.seletedQueston.emit(value);
  }
  getData(tables: string, currentVersionId: string) {
    const url = `/multi/tables/${tables}/versions/${currentVersionId}?isMultiGame=true`;
    this.http.get(url).subscribe((success: any) => {
      if (success && success.hasOwnProperty("records")) {
        const rows = success.records.length;
        this.newQuestionAddedSubject.next(rows);
        // ... Your existing code here
      }
    });
  }
  deleteRow(rowId: number) {
    // Your logic for deleting a row here
    // Once a row is deleted, call this method to update the rowsLength

    // Emit the row deletion event before completing the deletion
    this.rowDeletedSubject.next();
  }
  private wordJumble: any;

  setWordJumble(value: any) {
    this.wordJumble = value;
  }

  getWordJumble(): any {
    return this.wordJumble;
  }
  // private rowsSubjects = new BehaviorSubject<number>(1); // Initialize rowsLength to 1
  getRowsLength(practiceSetId: string): number {
    return this.rowsLengthPerPracticeSet[practiceSetId] || 1;
  }

  // Method to update the rowsLength for a specific practice set
  setRowsLength(practiceSetId: string, rowsLength: number) {
    this.rowsLengthPerPracticeSet[practiceSetId] = rowsLength;
  }

  // Create Members & Teams BreadCrumb
  membersAndTeamsBreadCrumb() {
    this.newAppBreadcrumb = true;
    localStorage.removeItem("previous_route");
    localStorage.removeItem("breadCrumb");
    this.breadCrumb = [];
    const membersAndTeamsBreadCrumbObj = {};
    membersAndTeamsBreadCrumbObj["name"] = "Members & Teams";
    membersAndTeamsBreadCrumbObj["url"] = "/main/memberTeams";
    membersAndTeamsBreadCrumbObj["icon"] = "fa fa-users";
    this.breadCrumb.push(membersAndTeamsBreadCrumbObj);
    localStorage.setItem("breadCrumb", JSON.stringify(this.breadCrumb));
  }

  getError(err) {
    if (err?.status == 401) {
      this.notifyInfo(AlertMessage.exitingCurrentSession);
      this.logmeout();
    }
  }

  // Pulls a displayable message out of an HttpErrorResponse. The backend sends the reason
  // either as a plain-string body or as `{ message: ... }`, and passing the raw body to a
  // snackbar renders "[object Object]" — so only strings are accepted, fallback otherwise.
  resolveErrorMessage(err: any, fallback: string): string {
    const candidates = [err?.error?.message, err?.error, err?.message];
    for (const candidate of candidates) {
      if (typeof candidate === "string" && candidate.trim()) {
        return candidate;
      }
    }
    return fallback;
  }

  getNameSuffix(name) {
    let res: string = "";
    if (!_.isUndefined(name) && (name != null || name != "")) {
      let splitNameList: any = name.trim().split(" ");
      if (splitNameList.length == 1) res = splitNameList[0].substring(0, 1).toUpperCase() + "" + splitNameList[0].substring(1, 2).toUpperCase();
      else res = splitNameList[0].substring(0, 1).toUpperCase() + "" + splitNameList[1].substring(0, 1).toUpperCase();
    }
    return res;
  }

  // SG-7550
  noEqualsAtStartValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const forbidden = /^=/.test(control.value);
      return forbidden ? { noEqualsAtStart: { value: control.value } } : null;
    };
  }

  // ***** SG-7866 START *****
  createLocalStorageMaps(mapName: string, key: string, value: string) {
    const storedMapData = localStorage.getItem(mapName);
    let map = new Map<string, string>();
    if (storedMapData) {
      const parsedData = JSON.parse(storedMapData);
      map = new Map<string, string>(parsedData);
    }

    map.set(key, value);
    localStorage.setItem(mapName, JSON.stringify(Array.from(map.entries())));
  }
  // ***** SG-7866 END *****

  sseSubscribe(sessionId: string) {
    const url = `${UserData.backend_url}/v1/sse/subscribe?sessionId=${sessionId}`;
    if (localStorage.getItem("sessionsId") === null || localStorage.getItem("sessionsId") === undefined) {
      localStorage.setItem("sessionsId", sessionId);

    }
    this.eventSource = new EventSource(url);

    this.eventSource.onopen = () => {
      console.log("Connection opened");
    };

    this.eventSource.onmessage = (event) => {
      console.log("Message received: " + event.data);
    };

    this.eventSource.addEventListener("login", (event: MessageEvent) => {
      const articleData = event.data;
      console.log(articleData);
      window.close();

      // setTimeout(() => {
      //   this.redirectToDashboard();
      // }, 5000);

      // const uniqueIdentifier = this.route.snapshot.queryParamMap.get('identifier');
      // const practiceSetId: any = new Map<string, string>(JSON.parse(localStorage.getItem('practiceSetIdMap'))).get(uniqueIdentifier);
      // const storedMapData = localStorage.getItem('practiceSetIdMap');
      // if (storedMapData) {
      //   const parsedData = JSON.parse(storedMapData);
      //   const map = new Map<string, string>(parsedData);
      //   for (const [key, value] of map) {
      //     if (value === practiceSetId) {
      //       map.delete(key);
      //       break;
      //     }
      //   }
      //   localStorage.setItem('practiceSetIdMap', JSON.stringify(Array.from(map.entries())));
      // }
    });

    this.eventSource.addEventListener("INIT", () => {
      console.log("Initialization event received.");
    });

    this.eventSource.addEventListener("error", (event: any) => {
     // console.error("Error:", event.currentTarget?.readyState);
      if (event.currentTarget?.readyState === EventSource.CLOSED) {
        console.log("EventSource connection closed.");
      } else {
        this.eventSource?.close();
      }
    });
  }

  sseUnsubscribe() {
    if (this.eventSource) {
      this.eventSource.close();
      console.log("EventSource connection closed on destroy.");
    }
  }

  redirectToDashboard() {
    setTimeout(() => {
      this.redirectToDashboardImmediately();
    }, 6000);
  }

  redirectToDashboardImmediately() {
    this.router.navigateByUrl("/main/content-management/dashboard").then(() => {
      window.location.reload();
    });

    sessionStorage.removeItem("nonProgrammaticEntry");
    sessionStorage.removeItem("terminateToken");
  }

  public getAirports(data, organizationId) {
    const url = this.apiUrl + "/organization/" + organizationId + "/airport-config?pageSize=10000&pageNo=0&sortField=airportName&sortDirection=asc&searchField=";
    return this.http.post(url, data);
  }
  /*
    public getGameNameById(gameId: string): Observable<string> {
      let organizationId: any = "noOrg";
      if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
      organizationId = organizationId == null || organizationId == "" ? "noOrg" : organizationId;
  
      const url = this.apiUrl + "/organizations/" + organizationId + "/gameName/" + gameId;
  
      // Important: tell Angular we expect a STRING
      return this.http.get(url, { responseType: 'text' });
    }*/

  public getGameNameById(gameId) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null || organizationId == "" ? "noOrg" : organizationId;

    const url = this.apiUrl + "/organizations/" + organizationId + "/gameName/" + gameId;
    return this.http.get(url);
  }

  public getExerciseById(exerciseId, requestedData) {
    const url =
      this.apiUrl + "/atc?requestedData=" + requestedData + "&exerciseId=" + exerciseId;
    return this.http.get(url);
  }

  public addMobileRouteForMeberAndTeam(){
    this.breadCrumb = [];
    var selectedTabIndex = this.hs.activeMemberTab$.value;
    this.showDateSelector = false;
    this.newAppBreadcrumb = false;
    if(selectedTabIndex == 0){
      this.breadCrumb = [
        {
          url: "main/analytics",
          name: "Analytics",
          icon: "",
        },
        {
          url: "main/memberTeams",
          name: "Member",
          icon: "",
        },
      ];
    } else if(selectedTabIndex == 2){
      this.showDateSelector = false;
      this.breadCrumb = [
        {
          url: "main/analytics",
          name: "Analytics",
          icon: "",
        },
        {
          url: "main/memberTeams",
          name: "Guest",
          icon: "",
        },
      ];
    }
    localStorage.setItem("breadCrumb", JSON.stringify(this.breadCrumb));
  }

  public async addMobileRouteForUserDetailsFromMemberAndTeam(name: string){
    this.showDateSelector = true;
    this.breadCrumb = [];
    var selectedTabIndex = this.hs.activeMemberTab$.value; 
    var nickName = localStorage.getItem('nickName');
    if (name && this.crypto.isProbablyEncrypted(name)) { 
      name = await this.crypto.decryptData(name);
    }
    if(selectedTabIndex == 0){
      this.breadCrumb = [
        {
          url: "main/analytics",
          name: "Analytics",
          icon: "",
        },
        {
          url: "main/memberTeams",
          name: "Member",
          icon: "",
        },
        {
          url: "main/user/details/" + nickName,
          name: name,
          icon: "fa fa-user",
        },
      ];
    } else if(selectedTabIndex == 2){ 
      var dataMB = this.hs.getMobileLoginData();
      var userRole = JSON.parse(localStorage.getItem('userRole'));
      if(dataMB && dataMB.nickName && userRole && userRole.toLocaleLowerCase() == "guest") {
        this.breadCrumb = [
          {
            url: "main/analytics",
            name: "Analytics",
            icon: "fa fa-user",
          },
          {
            url: "main/user/details/" + nickName,
            name: name,
            icon: "fa fa-user",
          },
        ];
      } else {
        this.breadCrumb = [
        {
          url: "main/analytics",
          name: "Analytics",
          icon: "",
        },
        {
          url: "main/memberTeams",
          name: "Guest",
          icon: "",
        },
        {
          url: "main/user/details/" + nickName,
          name: name,
          icon: "fa fa-user",
        },
      ];
      }
    }
    localStorage.setItem("breadCrumb", JSON.stringify(this.breadCrumb));
  }
}
